import "../style/home/H_AmazingSuggest.css";

import img1 from "../../assets/store/amazing-suggest/ella-olsson-KPDbRyFOTnE-unsplash.jpg";
import img2 from "../../assets/store/amazing-suggest/antoine-dautry-_zsL306fDck-unsplash.jpg";
import img3 from "../../assets/store/amazing-suggest/ahmed-almakhzanji-kshkB1i5_5o-unsplash.jpg";
import date_icon from "../../assets/store/calendar.png";
import hat_icon from "../../assets/store/teacher.png";
import type_icon from "../../assets/store/profile-2user.png";

import as_bg_img from "../../assets/store/Group 148.png";

import as_icon from "../../assets/store/discount-shape.png";
import { BsHeart } from "react-icons/bs";
// import { useSelector } from 'react-redux';
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import bag_icon from "../../assets/store/Group 127.png";

let as_data = [
  {
    id: 1,
    img: img1,
    title: "آزمون آشپزی شرق آسیا",
    // price:458.200,
    price: "458.200",
    date: "28 آبان 1400",
    level: "پایه 1 الی 12",
    type: "گروهی",
    user_num: 100,
  },
  {
    id: 2,
    img: img2,
    title: "آزمون مدارهای مخابراتی پیشرفته",
    // price:458.200,
    price: "458.200",
    date: "28 آبان 1400",
    level: "پایه 1 الی 12",
    type: "گروهی",
    user_num: 100,
  },
  {
    id: 3,
    img: img1,
    title: "آزمون آشپزی شرق آسیا",
    // price:458.200,
    price: "458.200",
    date: "28 آبان 1400",
    level: "پایه 1 الی 12",
    type: "گروهی",
    user_num: 100,
  },
  {
    id: 4,
    img: img3,
    title: "آزمون آشپزی شرق آسیا",
    // price:458.200,
    price: "458.200",
    date: "28 آبان 1400",
    level: "پایه 1 الی 12",
    type: "گروهی",
    user_num: 100,
  },
];

const H_AmazingSuggest = () => {
  return (
    <div className="h-amazing-suggest">
      <div className="as_bg_img">
        <img src={as_bg_img} alt="as_bg_img" />
      </div>
      <div className="amazing_suggest_title_box">
        <img src={as_icon} alt="amazing_suggest_icon" />
        <div className="as-stb-text">پیشنهاد شگفت انگیز</div>
      </div>
      <AmazingSuggestTimer />
      {as_data.map((item) => (
        <div key={item.id} className="as-item">
          <div className="as-item-img">
            <img src={item.img} alt="product-img" />
            <div className="spcp-item-img-cover"></div>
            <Link
              to={`/dashboard/store/amazing-suggest/${item.id}`}
              className="as-item-img-bag-icon"
            >
              <img src={bag_icon} alt="bag-icon" />
              <div className="as-item-img-bag-icon-hover-text">
                بررسی و خرید آزمون
              </div>
            </Link>
            <BsHeart className="as-item-img-heart-icon" />
            <div className="as-item-userNum-container">
              <div className="as-item-userNum">
                <div className="as-item-userNum-item"></div>
                <div className="as-item-userNum-item"></div>
                <div className="as-item-userNum-item"></div>
                <div className="as-item-userNum-item">+{item.user_num}</div>
              </div>
            </div>
          </div>
          <div className="as-item-title-and-price">
            <div className="as_item_img_withe_space"></div>
            <div className="as-itap-title">{item.title}</div>
            <div
              style={item.discount ? { justifyContent: "space-between" } : null}
              className="as-itap-price"
            >
              <div
                style={
                  item.discount
                    ? { color: "#888", textDecoration: "2px line-through" }
                    : null
                }
                className="as-itap-price-main"
              >
                {item.price} <span className="as-itap-price-unit">تومان</span>
              </div>
              {item.discount && (
                <div className="as-itap-price-discounted">
                  {item.discounted_price}{" "}
                  <span className="as-itap-price-unit">تومان</span>
                </div>
              )}
              {item.discount && (
                <div className="as-itap-price-discount">{item.discount}</div>
              )}
            </div>
          </div>
          <div className="as-item-info">
            <div className="as-item-info-date-box">
              <img src={date_icon} alt="date-icon" />
              <div className="as-iidb-text">{item.date}</div>
            </div>
            <div className="as-item-info-level-box">
              <img src={hat_icon} alt="hat-icon" />
              <div className="as-iilb-text">{item.level}</div>
            </div>
            <div className="as-item-info-type-box">
              <img src={type_icon} alt="type-icon" />
              <div className="as-iitb-text">{item.type}</div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

const AmazingSuggestTimer = () => {
  // console.log("AST renser.............");

  const event_end = new Date(2021, 8, 13, 23, 0, 0, 0);
  const now = new Date();
  let time_diff = (event_end - now) / 1000;
  const H = Math.floor(time_diff / 3600);
  const MIN = Math.floor((time_diff - H * 3600) / 60);
  const SEC = Math.floor(time_diff - (H * 3600 + MIN * 60));
  const [h, set_h] = useState(H);
  const [min, set_min] = useState(MIN);
  const [sec, set_sec] = useState(SEC);

  useEffect(() => {
    // console.log(sec);
    if (sec >= 0 && time_diff > 0) {
      setTimeout(() => {
        // console.log("okdkdokodkd");
        set_sec(sec - 1);
        if (sec === 0) {
          set_sec(59);
          set_min(min - 1);
        }
        if (min === 0) {
          set_h(h - 1);
          set_min(59);
        }
      }, 1000);
    }
  });

  return (
    <div className="amazing_suggest_timer">
      <div className="as-t-text">تا پایان شگفت انگیز</div>
      <div className="as-t-num-box">
        <div className="as-t-num-box-num">{sec}</div>
        <div className="as-t-num-box-text">ثانیه</div>
      </div>
      <div className="as-t-num-box">
        <div className="as-t-num-box-num">{min}</div>
        <div className="as-t-num-box-text">دقیقه</div>
      </div>
      <div className="as-t-num-box">
        <div className="as-t-num-box-num">{h}</div>
        <div className="as-t-num-box-text">ساعت</div>
      </div>
    </div>
  );
};

export default H_AmazingSuggest;
